import { useLocation } from 'react-router';
import { useAuthContext } from '../../../contexts/AuthContext';
import { canAccess } from '../../../utils/videowallPermissions';

export const ZoneRoute = ({ children }) => {
  const { tags, authReady, logout } = useAuthContext();
  const location = useLocation();

  // Wait until localStorage hydration is done before checking anything.
  if (!authReady) return null;

  if (canAccess(tags, location.pathname)) return children;

  // No redirect — show access denied in place to break the redirect cycle.
  const handleBackToLogin = async (e) => {
    e.preventDefault();
    await logout();
    window.location.href = '/';
  };

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh', gap: '16px',
      background: '#0a0a0a', color: '#fff', fontFamily: 'sans-serif'
    }}>
      <div style={{ fontSize: '52px' }}>⛔</div>
      <div style={{ fontSize: '22px', fontWeight: 700 }}>Access Denied</div>
      <div style={{ fontSize: '14px', color: '#888' }}>
        Your account does not have permission to access this zone.
      </div>
      <a href="/" onClick={handleBackToLogin} style={{
        marginTop: '12px', padding: '10px 24px', borderRadius: '8px',
        background: '#86BC25', color: '#fff', textDecoration: 'none',
        fontWeight: 700, fontSize: '14px'
      }}>
        ← Back to Login
      </a>
    </div>
  );
};
